import {addErrorSnack} from "../../domain/BarsENV/snack/store/slice";
import {store} from "../redux";

export const snackError = (message: string | { message: string, invalidToken?: boolean }) => store.dispatch(addErrorSnack(message));
